<template>
    <FavoriteTicketsSlider v-if="favoriteTickets.length" :favoriteTickets="favoriteTickets" />
</template>

<script setup lang="ts">
import { useFavoriteTicketsStore } from "../favorite-tickets-store";
import { storeToRefs } from "pinia";
import { watch, onMounted } from "vue";
import FavoriteTicketsSlider from "../components/favorite-tickets-slider.vue";

const store = useFavoriteTicketsStore();
const { favoriteTickets } = storeToRefs(store);

const updateWidgetVisibility = () => {
    const widgetElement = document.getElementById("cp-favorite-tickets");
    if (widgetElement) {
        if (favoriteTickets.value.length === 0) {
            widgetElement.style.display = "none";
        } else {
            widgetElement.style.display = "";
        }
    }
};

watch(
    favoriteTickets,
    () => {
        updateWidgetVisibility();
    },
    { immediate: true }
);

onMounted(() => {
    updateWidgetVisibility();
});
</script>
